import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

type ConfirmCoverageChangeDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  saving?: boolean;
  headline: string;
  body: string;
  confirmLabel: string;
};

export default function ConfirmCoverageChangeDialog({
  open,
  onClose,
  onConfirm,
  saving = false,
  headline,
  body,
  confirmLabel
}: ConfirmCoverageChangeDialogProps) {
  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline={headline}
      className="w-[560px] max-w-[95vw] max-h-[85vh]"
      disableClose={saving}
      actions={
        <>
          <Button variant="text" onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button
            variant="filled"
            theme="error"
            onClick={onConfirm}
            loading={saving}
            testId="confirm-coverage-change-save"
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p>{body}</p>
    </Dialog>
  );
}
